import { IntlTFunc } from 'next-intl';

import { FilterOption } from './types';

export const PAGE_SIZE = 36;

export const FILTERS_SLUG = {
  BRAND_NAME: 'brand_name',
  TYPE: 'promo_type'
} as const;

export const BRANDS_FILTERS: FilterOption[] = [
  {
    label: 'BIODERMA',
    value: 'bioderma',
    slug: FILTERS_SLUG.BRAND_NAME
  },
  {
    label: 'Institut Esthederm',
    value: 'esthederm',
    slug: FILTERS_SLUG.BRAND_NAME
  },
  {
    label: 'Etat Pur',
    value: 'etat_pur',
    slug: FILTERS_SLUG.BRAND_NAME
  }
] as const;

export const PROMOTION_TYPES_VALUES = {
  DISCOUNT: 'discount',
  PRESENT: 'gift',
  INCREASED_CASHBACK: 'increased_cashback',
  TWO_EQUAL_ONE: 'two_equal_one',
  ALL: 'all'
} as const;

export const PROMOTION_TYPES_LABELS = (t: IntlTFunc) => {
  return {
    all: t('promotions.promoTypeLabels.all'),
    discount: t('promotions.promoTypeLabels.dicount'),
    present: t('promotions.promoTypeLabels.present'),
    increased_cashback: t('promotions.promoTypeLabels.increasedCashback'),
    two_equal_one: t('promotions.promoTypeLabels.twoEqualOne')
  } as const;
};

export const TYPES_FILTERS = (t: IntlTFunc): FilterOption[] => {
  const labels = PROMOTION_TYPES_LABELS(t);
  return [
    {
      label: labels.all,
      value: PROMOTION_TYPES_VALUES.ALL,
      slug: FILTERS_SLUG.TYPE
    },
    {
      label: labels.discount,
      value: PROMOTION_TYPES_VALUES.DISCOUNT,
      slug: FILTERS_SLUG.TYPE
    },
    {
      label: labels.present,
      value: PROMOTION_TYPES_VALUES.PRESENT,
      slug: FILTERS_SLUG.TYPE
    },
    {
      label: labels.increased_cashback,
      value: PROMOTION_TYPES_VALUES.INCREASED_CASHBACK,
      slug: FILTERS_SLUG.TYPE
    },
    {
      label: labels.two_equal_one,
      value: PROMOTION_TYPES_VALUES.TWO_EQUAL_ONE,
      slug: FILTERS_SLUG.TYPE
    }
  ] as const;
};
